import { BusinessCategoriesResponseSchema, CitiesResponseSchema, CountriesResponseSchema } from './schema';
import { HTTP_METHOD } from '../../consts';
import type { ApiCallOptions, Transport } from '../../types';

/** Creates the core API methods for general-purpose endpoints. */
export const createCoreApi = (transport: Transport) => ({
  /** Fetches the list of all countries with their states */
  getCountries: (options?: ApiCallOptions) =>
    transport('/manage/v1/locations/countries', {
      method: HTTP_METHOD.GET,
      deserializer: CountriesResponseSchema,
      signal: options?.signal
    }),

  /** Fetches the list of cities for a given country */
  getCities: (country: string, options?: ApiCallOptions) =>
    transport(`/manage/v1/locations/cities`, {
      method: HTTP_METHOD.GET,
      deserializer: CitiesResponseSchema,
      queryParams: { country },
      signal: options?.signal
    }),

  /** Fetches business categories for a given country */
  getBusinessCategories: (country: string, options?: ApiCallOptions) =>
    transport(`/manage/v1/business-categories/${country}`, {
      method: HTTP_METHOD.GET,
      deserializer: BusinessCategoriesResponseSchema,
      signal: options?.signal
    })
});

export type CoreApi = ReturnType<typeof createCoreApi>;
